<template>
  <v-dialog v-model="dialogOpen" width="800" persistent>
    <v-card>
      <v-card-title>Domain &amp; Emails</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field dense outlined hide-details label="Domain Name" v-model="searchText" v-on:keyup.enter="openSearch" :disabled="updateWebsiteDetailsLoading">
              <v-icon slot="append" color="secondary" @click="openSearch">search</v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu ref="menu" max-width="400" v-model="menu" :close-on-content-click="false" :return-value.sync="renewalDate" transition="scale-transition" offset-y :disabled="updateWebsiteDetailsLoading">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="renewalDate" label="Domain Renewal Date" readonly dense outlined hide-details v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="renewalDate" full-width no-title scrollable :min="allowedDates" @change="$refs.menu.save(renewalDate)"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <template v-if="selectedDomain.name!==undefined">
          <v-divider></v-divider>
          <template v-for="email in getCurrentEmailsToEdit">
            <v-row :key="email.id">
              <v-col cols="12">
                <v-text-field dense outlined hide-details :label="(email.id===1)?`Included Email`:`Additional Email ${email.id-1}`" v-model="email.email" @change="checkEmails" :disabled="updateWebsiteDetailsLoading"></v-text-field>
              </v-col>
            </v-row>
          </template>
        </template>
        <template v-if="checkEmails">
          <v-row class="mt-n3">
            <v-col class="error--text">{{emailErrors}}</v-col>
          </v-row>
        </template>
        <v-row class="mt-n3"><v-col>To add email addresses, update the “Additional Email Address” add on.</v-col></v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="updateWebsiteDetailsLoading" :loading="updateWebsiteDetailsLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="updateWebsiteDetailsLoading">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
    <DomainNameSearchDialog :dialogOpen="domainEditOpen" @close-dialog="domainEditOpen=false;" :searchedText="searchText" />
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters,mapMutations } from "vuex";
  import DomainNameSearchDialog from './DomainNameSearchDialog';
  import moment from 'moment';

  export default {
    components: {DomainNameSearchDialog},
    props: ['dialogOpen'],
    data() {
      return {
        menu: false,
        searchText: '',
        renewalDate: '',
        emailErrors: '',
        domainEditOpen: false,
      }
    },
    watch: {
      dialogOpen(open){
        if(open){
          this.setSelectedDomain(this.websiteDetails.domain_name);
          this.renewalDate = this.websiteDetails.domain_renewal_date;
        }
      },
      selectedDomain(val) {
        if(val.name!==undefined){
          this.searchText = this.selectedDomain.full;
        }
      },
    },
    computed: {
      ...mapState('productWebsite',['websiteDetails','selectedDomain','updateWebsiteDetailsLoading']),
      ...mapGetters('productWebsite',['getCurrentEmailsToEdit']),
      allowedDates() {
        return moment(new Date()).format('YYYY-MM-DD');
      },
    },
    methods: {
      ...mapActions('productWebsite',['updateWebsiteDetails']),
      ...mapMutations('productWebsite',['setSelectedDomain']),
      checkEmails(){
        let errors = 0;
        this.getCurrentEmailsToEdit.forEach(obj => {
          if(/@/g.test(obj.email)){ errors++; }
        });
        this.emailErrors = (errors>0)?'Do not put @ in the email address, the domain name will be used automatically':'';
      },
      openSearch(){
        this.domainEditOpen = true;
      },
      async submit() {
        let data = {
          domain_name: this.selectedDomain.full,
          domain_renewal_date: this.renewalDate,
          email_addresses: this.getCurrentEmailsToEdit.map(e=>{return e.email;}),
        }
        let success = await this.updateWebsiteDetails(data);
        if(success){
          this.close();
        }
      },
      close() {
        this.setSelectedDomain(null);
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
